export const URL = '/api/'

export const URL_USERS = 'users/login/'

export const URL_EXERCISES = 'exercises/'

export const URL_WEIGHT = 'weights/'

export const URL_REPORT = 'reports/'

export const URL_HISTORY = 'history/'
